import { useEffect } from 'react';
import { useCallStore } from './stores/call-store';
import { Dialer } from './components/Dialer';
import { ActiveCalls } from './components/ActiveCalls';
import { CallHistory } from './components/CallHistory';
import { TestCradle } from './components/TestCradle';
import './App.css';

function App() {
  const { user, isConnected, isRegistered, setUser } = useCallStore();

  useEffect(() => {
    // Get extension from URL query param, default to 1000
    // Usage: http://localhost:5173/?ext=1001
    const params = new URLSearchParams(window.location.search);
    const ext = params.get('ext') || '1000';
    const extNum = parseInt(ext, 10);

    // Valid extensions are 1000-1019
    const extension = (extNum >= 1000 && extNum <= 1019) ? ext : '1000';

    const mockUser = {
      id: `550e8400-e29b-41d4-a716-44665544000${extension.slice(-1)}`,
      hubspot_user_id: `test-user-${extension}`,
      email: `test${extension}@example.com`,
      name: `Test User (Ext ${extension})`,
      phone_number: `+123456789${extension.slice(-1)}`,
      sip_username: extension,
    };
    setUser(mockUser);
  }, [setUser]);

  if (!user) {
    return (
      <div className="app loading">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <h1>SIP Gateway</h1>
        <div className="connection-status">
          <span className={`status-indicator ${isConnected ? 'connected' : 'disconnected'}`}>
            {isConnected ? '● ' : '○ '}
            {isConnected ? 'Connected' : 'Disconnected'}
          </span>
          <span className={`status-indicator ${isRegistered ? 'registered' : 'unregistered'}`}>
            {isRegistered ? '● ' : '○ '}
            {isRegistered ? 'Registered' : 'Unregistered'}
          </span>
        </div>
      </header>

      <main className="app-main">
        <div className="main-panel">
          <section className="dialer-section">
            <Dialer />
          </section>

          <section className="active-calls-section">
            <ActiveCalls />
          </section>

          <TestCradle />
        </div>

        <aside className="sidebar">
          <CallHistory />
        </aside>
      </main>
    </div>
  );
}

export default App;
